export function fieldError(meta) {
  return (
    meta.touched &&
    (meta.error || (meta.submitError && !meta.dirtySinceLastSubmit)) &&
    !meta.submitting &&
    (meta.error || meta.submitError)
  )
}
